/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate, useRoutes } from 'react-router-dom';
import { connect } from 'react-redux';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { create } from 'jss';
import { ThemeProvider } from 'styled-components/macro';
import { StyledEngineProvider } from '@mui/styled-engine-sc';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import StylesProvider from '@mui/styles/StylesProvider';
import jssPreset from '@mui/styles/jssPreset';
import createTheme from './theme';
import routes from './routes';
import useTheme from './hooks/useTheme';
import Spinner from './pages/components/Loading';
import { socket } from './sockets/socket';
import { handleOnlineUsers } from './actions/SessionActions';
import { logout } from './actions/AuthActions';
import swal from 'sweetalert';

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById('jss-insertion-point'),
});

function App({ auths, handleOnlineUsers, logout }) {
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const [loader, setLoader] = useState(true);
  const [permission, setPermissions] = useState([]);
  const [final, setFinal] = useState([]);
  const navigate = useNavigate();
  let userRoutes = [];

  useEffect(async () => {
    await new Promise((resolve, reject) => {
      setLoader(true);
      if (auths.user) {
        resolve(setPermissions(auths.user?.role?.permissions));
      }
    });
  }, [auths.user]);

  useEffect(() => {
    routes.map((route, idx) => {
      userRoutes.push({
        path: route.path,
        element: route.element,
        children: [],
      });
      route.children.map((child) => {
        child.allowedRole.map((role) => {
          if (
            (permission && permission.includes(role)) ||
            role === '*' ||
            (authData?.type === 'super_admin' && !child?.notAllowed)
          ) {
            userRoutes[idx].children.push(child);
          }
        });
      });
    });
    setFinal(userRoutes);
  }, [permission]);

  useEffect(() => {
    if (final.length) {
      setLoader(false);
    }
  });

  const content = useRoutes(final);
  const { theme } = useTheme();

  useEffect(() => {
    socket.on('ap_online_users', (data) => {
      if (Array.isArray(data)) {
        handleOnlineUsers(data);
      }
    });
    socket.on('force_logout', async () => {
      swal('Session Expired', `Please login again`, 'info').then(async () => {
        await logout();
        navigate('/login');
      });
    });

    return () => {
      socket.off('ap_online_users', () => {
        console.log('CLEANING UP');
      });
      socket.off('force_logout', async () => {
        console.log('CLEANING UP');
      });
    };
  }, []);

  if (!loader) {
    return (
      <HelmetProvider>
        <Helmet titleTemplate='%s' defaultTitle='Alpha Plus' />
        <StylesProvider jss={jss}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StyledEngineProvider injectFirst>
              <MuiThemeProvider theme={createTheme(theme)}>
                <ThemeProvider theme={createTheme(theme)}>{content}</ThemeProvider>
              </MuiThemeProvider>
            </StyledEngineProvider>
          </LocalizationProvider>
        </StylesProvider>
      </HelmetProvider>
    );
  } else {
    return <Spinner />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, { handleOnlineUsers, logout })(App);
